import React from 'react';
export function SiteFooter() {
  const year = new Date().getFullYear();
  const links = ['Términos y Condiciones', 'Política de Privacidad', 'Contacto', 'Garantía'];
  return <footer className="w-full bg-ink py-10 text-gray-400" data-id="element-238">
      <div className="mx-auto max-w-5xl px-4 text-center" data-id="element-239">
        <p className="font-display text-xl font-600 text-white" data-id="element-240">
          Pollería Rentable 2026
        </p>
        <nav aria-label="Enlaces del pie de página" className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-241">
          {links.map(l => <a key={l} href="#" className="transition-colors hover:text-gold-light" data-id="element-242">
              {l}
            </a>)}
        </nav>
        <p className="mt-6 text-xs leading-relaxed text-gray-500" data-id="element-243">
          © {year} Pollería Rentable 2026. Todos los derechos reservados. Este
          sitio no es parte de Facebook ni de ninguna plataforma de terceros.
        </p>
      </div>
    </footer>;
}